import React, { useContext } from 'react';

import classNames from 'classnames';

import cls from './TabPanel.module.css';
import { Context } from '../../AddPayments';

export const TabPanel = ({ activeTab, setActiveTab, isDisabled = false }) => {
    const { modalState, setModalState } = useContext(Context);

    return (
        <div className={classNames(cls.tabPanel)}>
            <div
                onClick={() => {
                    if (!isDisabled) {
                        setActiveTab('debit');
                        setModalState((prevState) => ({ ...prevState, mode: 'debit' }));
                    }
                }}
                className={classNames(cls.tabPanelItem, {
                    [cls.active]: activeTab === 'debit',
                    [cls.disabled]: isDisabled,
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 4L12 12M12 12V6.66667M12 12H6.66667"
                        stroke="#757575"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                {i18next.t('TabPanel.tabPanelItem.income')}
            </div>
            <div
                onClick={() => {
                    if (!isDisabled) {
                        setActiveTab('credit');
                        setModalState((prevState) => ({ ...prevState, mode: 'credit' }));
                    }
                }}
                className={classNames(cls.tabPanelItem, {
                    [cls.active]: activeTab === 'credit' || activeTab === 'transfer',
                    [cls.disabled]: isDisabled,
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 12L4 4M4 4V9.33333M4 4H9.33333"
                        stroke="#757575"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                {i18next.t('TabPanel.tabPanelItem.payment')}
            </div>
        </div>
    );
};
